import { ComponentType } from '@wix/a11y-adapters';
export let DsDataSource = /*#__PURE__*/function (DsDataSource) {
  DsDataSource["Studio"] = "studio";
  DsDataSource["Platformized"] = "platformized";
  return DsDataSource;
}({});
export const AUTO_DOM_ORDER_DATE = new Date('2024-11-07');
export let ProductsDataSource = /*#__PURE__*/function (ProductsDataSource) {
  ProductsDataSource["Graphql"] = "graphql";
  ProductsDataSource["V1"] = "v1";
  ProductsDataSource["V3"] = "v3";
  return ProductsDataSource;
}({});
export const A11Y_RULES_EXPERIMENTS = {
  DISABLE_ALT_TEXT_AND_MEDIA_ALT_FOR_TEMPLATES_QA: 'specs.a11y.disableAltTextAndMediaAltForTemplatesQA',
  EDITABLE_RESTAURANTS_MENU_ALT_TEXT: 'editableRestaurantsMenuAltText',
  ENABLE_A11Y_EVENTS_ALT_RULE_MAIN_IMAGES: 'specs.responsive-editor.EnableA11yEventsAltRuleMainImages',
  // Gift card alt text. Conductor spec (no dots). Read by both the scan
  // service (fetch-tpa-components) and the wizard (use-tpa-entity-data-handlers).
  ENABLE_GIFT_CARD: 'a11yEnableGiftCard',
  // Pricing plans scan. Conductor spec (no dots), migrated from the petri spec
  // specs.a11y.enablePricingPlan. Read by both the scan service (categorize-page
  // via conduct-all-experiments) and the wizard/editor panel (item-type config
  // `enabledBy`).
  ENABLE_PRICING_PLAN: 'a11yEnablePricingPlan',
  // Referral pages scan. Conductor spec (no dots). Test-only, off by default.
  // Gates whether the Wix Referrals refer-friend / referral pages are scanned
  // (as generic static pages) instead of excluded. WIXSEO-1892.
  ENABLE_REFERRAL: 'a11yEnableReferral'
};
export const CONTAINER_COMPONENT_TYPES = [ComponentType.Section, ComponentType.ClassicSection, ComponentType.FooterSection, ComponentType.HeaderSection, ComponentType.Column, ComponentType.HeaderContainer, ComponentType.FooterContainer, ComponentType.StripContainerSlideShowSlide, ComponentType.StripColumnsContainer, ComponentType.PaginatedGridGallery, ComponentType.BoxSlideShow, ComponentType.BoxSlideShowSlide, ComponentType.Tabs];

// To do - studio needs to expose this array
// https://github.com/wix-private/document-management/blob/62ef609b0fddbf26701d620cc81a1165945579c1/document-services-implementation/src/siteMetadata/generalInfoUtils.ts#L1
export const RTL_LANGUAGES = ['ar', 'arc', 'bcc', 'bqi', 'ckb', 'dv', 'fa', 'glk', 'ha', 'he', 'khw', 'ks', 'ku', 'mzn', 'pnb', 'ps', 'sd', 'ug', 'ur', 'yi'];
export let ConsumerProfile = /*#__PURE__*/function (ConsumerProfile) {
  ConsumerProfile["Default"] = "default";
  ConsumerProfile["SEO"] = "seo";
  ConsumerProfile["A11Y"] = "a11y";
  ConsumerProfile["PMA"] = "pma";
  return ConsumerProfile;
}({});
export const MASTER_PAGE_ID = 'masterPage';
export let MembersCustomPageManagedByWixAppId = /*#__PURE__*/function (MembersCustomPageManagedByWixAppId) {
  MembersCustomPageManagedByWixAppId["SignUp"] = "5f4fa4f1-5afd-4ac0-8a85-e5ac1d2b9b7d";
  MembersCustomPageManagedByWixAppId["SignIn"] = "bbe1406a-31f5-4f3f-9e0a-b39dfd25274f";
  return MembersCustomPageManagedByWixAppId;
}({});
export const DEFAULT_BRANCH_ID = '00000000-0000-0000-0000-000000000000';
//# sourceMappingURL=constants.js.map